(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('.section-header');
      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.currentScrollTop = window.scrollY;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('tsdc-live-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.setHeaderHeight.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.setHeaderHeight();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.onResizeHandler);
        this.resizeObserver.observe(this.header);
      }
    }

    setHeaderHeight() {
      if (!this.header) return;

      this.headerHeight = this.header.offsetHeight;

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.headerHeight}px`
      );

      if (!this.header.classList.contains('shopify-section-header-sticky')) {
        this.headerTop = this.header.getBoundingClientRect().top + window.scrollY;
      } else if (typeof this.headerTop !== 'number') {
        this.headerTop = this.header.offsetTop;
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      window.clearTimeout(this.isScrolling);
    }

    onScroll() {
      const scrollTop = window.scrollY;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const headerBottom = (this.headerTop || 0) + this.headerHeight;

      if (scrollTop > this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventHide) this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          this.hide();
        }
      } else if (scrollTop <= (this.headerTop || 0)) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.header.querySelectorAll('header-menu').forEach((menu) => {
        if (typeof menu.close === 'function') menu.close();
      });

      const modal = this.header.querySelector('details-modal');
      if (modal && typeof modal.close === 'function') modal.close(false);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
